import { render, staticRenderFns } from "./fillPriceDifference.vue?vue&type=template&id=70a69bc4&scoped=true"
import script from "./fillPriceDifference.vue?vue&type=script&lang=js"
export * from "./fillPriceDifference.vue?vue&type=script&lang=js"
import style0 from "./fillPriceDifference.vue?vue&type=style&index=0&id=70a69bc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a69bc4",
  null
  
)

export default component.exports